@if (vm$ | async; as vm) {
  <mat-accordion multi="true">
    <mat-nav-list>
      <a mat-list-item routerLink="/home">Home</a>
      @if (vm.portalUser && vm.moduleTabs) {
        @for (tab of vm.moduleTabs; track tab.label) {
          <mat-expansion-panel mat-list-item class="mat-elevation-z0">
            <mat-expansion-panel-header>
              <mat-panel-title>{{ tab.label }}</mat-panel-title>
            </mat-expansion-panel-header>
            <mat-nav-list>
              @for (tile of tab.tiles; track tile.enumeration) {
                @if (
                  tile.hideFromNavigation === undefined ||
                  !tile.hideFromNavigation
                ) {
                  <a mat-list-item [routerLink]="tile.routes[0]">{{
                    tile.name
                  }}</a>
                }
              }
            </mat-nav-list>
          </mat-expansion-panel>
        }
      }
    </mat-nav-list>
  </mat-accordion>
}
